import { useEffect, useRef } from 'react';

export const HtmlContent = ({
  documentFragment,
  as = 'div',
}: {
  documentFragment: DocumentFragment;
  as?: 'span' | 'div';
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    ref.current?.replaceChildren(documentFragment.cloneNode(true));
  }, [documentFragment]);

  const hasChildren = documentFragment.hasChildNodes();

  if (!hasChildren) return false;

  return as === 'div' ? <div ref={ref} /> : <span ref={ref} />;
};
